module.exports = __webpack_public_path__ + "img/qrcode.b8ce85dd.png";